export default "__VITE_ASSET__CX4G4kCB__"